import React, {PropsWithChildren, useContext} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {Company} from "../models/company.model";

export const CompanyContext = React.createContext({} as Company);

export const CompanyProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <CompanyContext.Provider value={data.company}>
            {children}
        </CompanyContext.Provider>
    )
}